"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showFailureBanner = exports.showSuccessBanner = exports.displayModal = exports.AppActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _utils = require("ReduxMessenger/utils");

var AppActionTypes = (0, _namespacedKeyMirror.default)({
  DISPLAY_MODAL: null,
  SUCCESS_BANNER: null,
  FAILURE_BANNER: null
}, 'users');
exports.AppActionTypes = AppActionTypes;
var displayModal = (0, _fluxActions.createAction)(AppActionTypes.DISPLAY_MODAL, (0, _actions.mapPayloadTo)('data'));
exports.displayModal = displayModal;
var showSuccessBanner = (0, _fluxActions.createAction)(AppActionTypes.SUCCESS_BANNER, function () {}, function (title, body) {
  return {
    notification: (0, _utils.createSuccessNotification)(title, body)
  };
});
exports.showSuccessBanner = showSuccessBanner;
var showFailureBanner = (0, _fluxActions.createAction)(AppActionTypes.FAILURE_BANNER, function () {}, function (title, body) {
  return {
    notification: (0, _utils.createDangerNotification)(title, body)
  };
});
exports.showFailureBanner = showFailureBanner;